<template>
  <div>
    <div class="page-header"><h2><span class="breadcrumb-level">数据统计</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">分析报告</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">收藏分析</span></h2></div>
    <el-row :gutter="20" class="metrics-row">
      <el-col :span="8"><el-card shadow="hover" class="metric-card">
        <div class="metric-value">{{ data.total }}</div>
        <div class="metric-label">收藏总数</div>
      </el-card></el-col>
      <el-col :span="8"><el-card shadow="hover" class="metric-card">
        <div class="metric-value">{{ data.today_new }}</div>
        <div class="metric-label">今日新增</div>
      </el-card></el-col>
      <el-col :span="8"><el-card shadow="hover" class="metric-card">
        <div class="metric-value">{{ typeCount }}</div>
        <div class="metric-label">收藏类型</div>
      </el-card></el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-card shadow="hover"><template #header><span style="font-weight:600">收藏类型分布</span></template>
          <div class="pie-list">
            <div class="pie-item" v-for="s in typeList" :key="s.label">
              <span class="pie-dot" :style="{ background: s.color }"></span>
              <span class="pie-label">{{ s.label }}</span>
              <span class="pie-bar-bg"><span class="pie-bar-fill" :style="{ width: pct(s.count) + '%', background: s.color }"></span></span>
              <span class="pie-val">{{ s.count }}</span>
            </div>
            <div v-if="typeList.length === 0" style="text-align:center;padding:30px;color:#999">暂无收藏数据</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover"><template #header><span style="font-weight:600">近7天收藏趋势</span></template>
          <div class="bar-chart-wrap"><div class="bar-chart">
            <div class="bar-item" v-for="(item, i) in raw.trends" :key="i">
              <div class="bar-bar" :style="{ height: barH(item.count) + '%' }"><span class="bar-num">{{ item.count }}</span></div>
              <div class="bar-label">{{ item.date.slice(5) }}</div>
            </div>
          </div></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import * as api from '../../api/statistics';

const raw = ref({});
const data = computed(() => raw.value.stats || {});
const colors = ['#409eff', '#67c23a', '#e6a23c', '#f56c6c', '#9b59b6', '#1abc9c', '#e67e22', '#95a5a6'];
const typeList = computed(() => (raw.value.by_type || []).map((s, i) => ({ ...s, color: colors[i % colors.length] })));
const typeCount = computed(() => typeList.value.length);
const total = computed(() => typeList.value.reduce((a, b) => a + (b.count || 0), 0) || 1);
const pct = (count) => ((count / total.value) * 100).toFixed(1);
const barH = (count) => { const arr = raw.value.trends || []; const max = Math.max(...arr.map(t => t.count || 0), 1); return Math.max(4, (count / max) * 100); };

onMounted(async () => { try { const r = await api.getFavoriteStats(); raw.value = r.data || {}; } catch {} });
</script>

<style scoped>
.metrics-row { margin-bottom: 24px; }
.metric-card { text-align: center; padding: 10px 0; }
.metric-value { font-size: 36px; font-weight: 700; color: #409eff; line-height: 1.2; }
.metric-label { font-size: 14px; color: #606266; margin-top: 6px; }
.bar-chart-wrap { padding: 10px 0; }
.bar-chart { display: flex; align-items: flex-end; justify-content: space-around; height: 200px; }
.bar-item { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: flex-end; height: 100%; }
.bar-bar { width: 40px; background: linear-gradient(180deg, #409eff, #79bbff); border-radius: 6px 6px 2px 2px; min-height: 8px; display: flex; align-items: flex-start; justify-content: center; padding-top: 4px; transition: height 0.5s; }
.bar-num { font-size: 12px; color: #fff; font-weight: 600; }
.bar-label { font-size: 12px; color: #909399; margin-top: 8px; }
.pie-list { padding: 6px 12px; }
.pie-item { display: flex; align-items: center; padding: 10px 0; border-bottom: 1px solid #f5f5f5; gap: 10px; }
.pie-item:last-child { border-bottom: none; }
.pie-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.pie-label { width: 70px; font-size: 13px; color: #606266; }
.pie-bar-bg { flex: 1; height: 8px; background: #f0f0f0; border-radius: 4px; overflow: hidden; }
.pie-bar-fill { display: block; height: 100%; border-radius: 4px; transition: width 0.6s ease; }
.pie-val { width: 50px; text-align: right; font-size: 15px; font-weight: 600; color: #303133; }
</style>
